import { Component, OnInit, OnDestroy } from '@angular/core';
import { Zona } from '@app/entidades/admin.model';
import { AdminService } from '@app/servicios/admin/admin.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-zonas',
  templateUrl: './zonas.component.html',
  styleUrls: ['./zonas.component.css'],
})
export class ZonasComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription = new Subscription();
  zonas: Zona[] = [];

  constructor(private adminService: AdminService) {}

  ngOnInit(): void {
    this.consultarZonas();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  consultarZonas(): void {
    this.subscriptions.add(
      this.adminService.consultarZonas().subscribe({
        next: (resp) => {
          if (resp && resp.data) {
            // Filtra solo si explícitamente está inactivo ('NO', '0', false)
            this.zonas = resp.data.filter(
              (z: any) => z.activo !== 'NO' && z.activo !== '0' && z.activo !== false
            );
          } else {
            this.zonas = [];
          }
        },
        error: (err) => {
          console.error('Error al consultar zonas:', err);
        },
      })
    );
  }
}
